<script lang="ts">
  import type { ApiField } from '../../data-tables-api';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  const stringValue = $derived(value != null ? String(value) : '');

  /** Базова normalize → намагаємось зберігати у форматі +XXX… (E.164 light).
   *  Точну валідацію виконує backend через libphonenumber-js. */
  function normalize(raw: string): string | null {
    const trimmed = raw.trim();
    if (!trimmed) return null;
    return trimmed;
  }
</script>

<input
  type="tel"
  value={stringValue}
  oninput={(e) => onChange(normalize((e.target as HTMLInputElement).value))}
  required={field.required}
  {disabled}
  autocomplete="tel"
  placeholder="+380501234567"
  class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-pu)] {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
/>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
